/* eslint-disable react/no-array-index-key */
import { useTranslation } from 'react-i18next';
import { PDPPreviewImage } from 'autogen/translation-keys/trans-website-imagealttext';
import { format } from 'modules/helpers/strings';
import { type GalleryMediaItems, MediaItemDiscriminator } from '../shared/types';
import PreviewGallery360Item from './Gallery360Item/Gallery360Item';
import PreviewGalleryHighlightedVideoItem from './GalleryHighlightedVideoItem/GalleryHighlightedVideoItem';
import PreviewGalleryImageItem from './GalleryImageItem/GalleryImageItem';
import PreviewGalleryVideoItem from './GalleryVideoItem/GalleryVideoItem';

export default function GalleryPreviewSlideRenderer({ items }: { items: GalleryMediaItems }) {
    const { t } = useTranslation();

    return (
        <>
            {items.map((item, index) =>
                MediaItemDiscriminator(
                    item,
                    (imageItemModel) => (
                        <PreviewGalleryImageItem
                            key={index}
                            imageItem={imageItemModel}
                            aria-label={format(t(PDPPreviewImage))(index + 1)}
                        />
                    ),
                    (videoItemModel) => <PreviewGalleryVideoItem key={index} videoItem={videoItemModel} />,
                    (highlightedVideoItemModel) => (
                        <PreviewGalleryHighlightedVideoItem
                            key={index}
                            highlightedVideoItem={highlightedVideoItemModel}
                        />
                    ),
                    (product360ItemModel) => <PreviewGallery360Item key={index} product360Item={product360ItemModel} />,
                    () => null
                )
            )}
        </>
    );
}
